"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[240],{

/***/ 46073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65457);
/* harmony import */ var _features_main_store_interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30053);
/* harmony import */ var _share_configs_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55016);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64035);
/* harmony import */ var antd_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13408);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31567);
/* harmony import */ var _features_share_helper_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79704);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);










var ThemeTemplateLists = function(props) {
    var ref, ref1;
    var themeTemplateData = props.themeTemplateData, onSelectTheme = props.onSelectTheme, onEditTheme = props.onEditTheme, onDeleteTheme = props.onDeleteTheme, KEY = props.KEY, onShowHideTheme = props.onShowHideTheme;
    var popoverRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)().t;
    var passioPageProfile = (0,_app_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        return creator_role === _features_main_store_interface__WEBPACK_IMPORTED_MODULE_2__/* .CREATOR_ROLE_ENUM.ADMIN */ .lp.ADMIN;
    }, [
        creator_role
    ]);
    var getAction = function(item) {
        return [
            {
                key: "edit-theme-template",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CommentInformationIcon */ .ci, {
                    className: "w-5 h-5",
                    fillColor: "white"
                }),
                text: t("ss_builder_edit_theme_template_label")
            },
            {
                key: (item === null || item === void 0 ? void 0 : item.status) === 1 ? "hide-theme-template" : "show-theme-template",
                icon: (item === null || item === void 0 ? void 0 : item.status) !== 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .EyeVisibleIcon */ .m0, {
                    className: "w-5 h-5"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .EyeHiddenIcon */ .Fl, {
                    className: "w-5 h-5"
                }),
                text: (item === null || item === void 0 ? void 0 : item.status) === 1 ? t("ss_builder_hide_theme_template_label") : t("ss_builder_show_theme_template_label")
            },
            {
                key: "delete-theme-template",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .DeleteIcon */ .pJ, {
                    className: "w-5 h-5"
                }),
                text: t("ss_builder_delete_theme_template_label")
            }, 
        ];
    };
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), selectedThemeData = ref2[0], setSelectedThemeData = ref2[1];
    var handleSelectThemeTemplate = function(themeData) {
        if (KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .THEME_RENDER_LIST_KEY.THEME_OVERWRITE_SELECTION */ .q9.THEME_OVERWRITE_SELECTION) {
            if (themeData.id === (selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id)) {
                setSelectedThemeData(null);
            } else {
                setSelectedThemeData(themeData);
            }
        } else {
            onSelectTheme(themeData);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        onSelectTheme(selectedThemeData);
    }, [
        selectedThemeData
    ]);
    var handleClickMoreIcon = function(event) {
        event.preventDefault();
    // event.stopPropagation();
    };
    var handleClickPopoverItem = function(item, themeId) {
        var key = item && item.key;
        var themeData = themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.find(function(x) {
            return x.id === themeId;
        });
        switch(key){
            case "edit-theme-template":
                handleEditThemeTemplate(themeData);
                break;
            case "delete-theme-template":
                handleDeleteThemeTemplate(themeId);
                break;
            case "hide-theme-template":
                handleShowHideThemeTemplate(themeId);
                break;
            case "show-theme-template":
                handleShowHideThemeTemplate(themeId);
                break;
            default:
        }
    };
    var handleEditThemeTemplate = function(themeData) {
        onEditTheme(themeData);
    };
    var handleShowHideThemeTemplate = function(themeId) {
        onShowHideTheme(themeId);
    };
    var handleDeleteThemeTemplate = function(themeId) {
        antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Modal.confirm */ .u_.confirm({
            header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .InformationTriangleIcon */ .Lm, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: t("ss_builder_confirm_delete_theme_template_modal_title")
            }),
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm_delete_theme_template_modal_content")
            }),
            confirmText: t("ss_builder_confirm_delete_theme_template_modal_btn_label"),
            cancelText: t("ss_builder_cancel_delete_theme_template_modal_btn_label"),
            onConfirm: function() {
                onDeleteTheme(themeId);
            },
            onCancel: function() {
                return;
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-4 pt-4 pb-[65px] bg-white",
        ref: popoverRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-3 gap-3 theme-store-tour-step-2 bg-[#fff] mb-3",
                children: (ref = themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.slice(0, 3)) === null || ref === void 0 ? void 0 : ref.map(function(ele, index) {
                    var listActions = getAction(ele);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("relative cursor-pointer", ele.status !== 1 && "opacity-40"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        // src={getHorizontalResizeUrl(ele.image)}
                                        // fit="cover"
                                        style: {
                                            background: 'url("'.concat((0,_features_share_helper_image__WEBPACK_IMPORTED_MODULE_7__/* .getHorizontalResizeUrl */ .L)(ele.image), '")'),
                                            aspectRatio: "9/16",
                                            borderRadius: "4px",
                                            border: ele.id === (selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id) ? "2px solid #EE3244" : "2px solid #00000029",
                                            backgroundPosition: "center top",
                                            backgroundSize: "cover"
                                        },
                                        onClick: function() {
                                            return handleSelectThemeTemplate(ele);
                                        }
                                    }),
                                    ele.id === (selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-2 right-2 rounded-full bg-[#EE3244]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIconV2 */ .lo, {
                                            className: "w-5 h-5 ",
                                            fillColor: "white"
                                        })
                                    }),
                                    KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .THEME_RENDER_LIST_KEY.THEME_STORE */ .q9.THEME_STORE && isAdminRole && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-2 right-2 rounded-[4px] bg-[#00000099] p-[2px] z-[6]",
                                        onClick: handleClickMoreIcon,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Popover.Menu */ .J2.Menu, {
                                            mode: "dark",
                                            actions: listActions,
                                            placement: "bottom",
                                            trigger: "click",
                                            stopPropagation: [
                                                "click"
                                            ],
                                            getContainer: function() {
                                                return popoverRef.current;
                                            },
                                            onAction: function(item) {
                                                return handleClickPopoverItem(item, ele.id);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .MoreIcon */ .nX, {
                                                className: "w-4 h-4 ",
                                                fillColor: "white"
                                            })
                                        })
                                    }),
                                    (ele === null || ele === void 0 ? void 0 : ele.is_premium) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-[6px] right-[6px] rounded-[4px] p-[2px] z-[5]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CrownIcon */ .CE, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs leading-4 text-[#8C8C8C] mt-2 text-ellipsis overflow-hidden whitespace-nowrap",
                                children: ele.title
                            })
                        ]
                    }, ele.id);
                })
            }),
            themeTemplateData.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-3 gap-3",
                children: (ref1 = themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.slice(3)) === null || ref1 === void 0 ? void 0 : ref1.map(function(ele, index) {
                    var listActions = getAction(ele);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("relative cursor-pointer", ele.status !== 1 && "opacity-40"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        // src={getHorizontalResizeUrl(ele.image)}
                                        // fit="cover"
                                        style: {
                                            background: 'url("'.concat((0,_features_share_helper_image__WEBPACK_IMPORTED_MODULE_7__/* .getHorizontalResizeUrl */ .L)(ele.image), '")'),
                                            aspectRatio: "9/16",
                                            borderRadius: "4px",
                                            border: ele.id === (selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id) ? "2px solid #EE3244" : "2px solid #00000029",
                                            backgroundPosition: "center top",
                                            backgroundSize: "cover"
                                        },
                                        onClick: function() {
                                            return handleSelectThemeTemplate(ele);
                                        }
                                    }),
                                    ele.id === (selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-2 right-2 rounded-full bg-[#EE3244]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CheckCircleIconV2 */ .lo, {
                                            className: "w-5 h-5 ",
                                            fillColor: "white"
                                        })
                                    }),
                                    KEY === _share_configs_const__WEBPACK_IMPORTED_MODULE_3__/* .THEME_RENDER_LIST_KEY.THEME_STORE */ .q9.THEME_STORE && isAdminRole && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-2 right-2 rounded-[4px] bg-[#00000099] p-[2px] z-[6]",
                                        onClick: handleClickMoreIcon,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Popover.Menu */ .J2.Menu, {
                                            mode: "dark",
                                            actions: listActions,
                                            placement: "bottom",
                                            trigger: "click",
                                            stopPropagation: [
                                                "click"
                                            ],
                                            getContainer: function() {
                                                return popoverRef.current;
                                            },
                                            onAction: function(item) {
                                                return handleClickPopoverItem(item, ele.id);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .MoreIcon */ .nX, {
                                                className: "w-4 h-4 ",
                                                fillColor: "white"
                                            })
                                        })
                                    }),
                                    (ele === null || ele === void 0 ? void 0 : ele.is_premium) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-[6px] right-[6px] rounded-[4px] p-[2px] z-[5]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* .CrownIcon */ .CE, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs leading-4 text-[#8C8C8C] mt-2 text-ellipsis overflow-hidden whitespace-nowrap",
                                children: ele.title
                            })
                        ]
                    }, ele.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ThemeTemplateLists);


/***/ }),

/***/ 19747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Logged; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92145);
/* harmony import */ var _features_user_userSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79206);
/* harmony import */ var _features_user_userApi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63681);
/* harmony import */ var _app_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77510);
/* harmony import */ var _features_share_helper_system__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98390);
/* harmony import */ var _share_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85861);
/* harmony import */ var _features_main_store_passioPageProfileSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69067);
/* harmony import */ var _features_mini_store_share_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25109);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _features_main_store_creatorProfileSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72976);
/* harmony import */ var _features_main_store_bookingProfileSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66625);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}














function Logged(param) {
    var children = param.children;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var kol = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_features_user_userSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectProfile */ .tM);
    var fetchAccount = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, response, getPackageOfUse, profile, passioPageProfile, creatorProfile, bookingProfile, allowStore;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return _features_user_userApi__WEBPACK_IMPORTED_MODULE_5__/* ["default"].me */ .ZP.me();
                    case 4:
                        response = _ctx.sent;
                        _ctx.next = 7;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_7__/* .getPackageOfUser */ .iF)();
                    case 7:
                        getPackageOfUse = _ctx.sent;
                        profile = _objectSpread({}, response, {
                            package_type: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref = getPackageOfUse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.language) === null || ref2 === void 0 ? void 0 : ref2.id,
                            package_name: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref3 = getPackageOfUse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.language) === null || ref5 === void 0 ? void 0 : ref5.name,
                            package_description: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref6 = getPackageOfUse.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.language) === null || ref8 === void 0 ? void 0 : ref8.description
                        });
                        // dispatch(setProfile(response));
                        dispatch((0,_features_user_userSlice__WEBPACK_IMPORTED_MODULE_4__/* .setProfile */ .RG)(profile));
                        _ctx.next = 12;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_7__/* .fetchPassioPageProfile */ .Qi)(response._id);
                    case 12:
                        passioPageProfile = _ctx.sent;
                        dispatch((0,_features_main_store_passioPageProfileSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPassioPageProfile */ .gA)({
                            data: passioPageProfile
                        }));
                        _ctx.next = 16;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_7__/* .fetchCreatorProfile */ .H$)();
                    case 16:
                        creatorProfile = _ctx.sent;
                        _ctx.next = 19;
                        return (0,_share_api__WEBPACK_IMPORTED_MODULE_7__/* .fetchBookingProfile */ .Kv)();
                    case 19:
                        bookingProfile = _ctx.sent;
                        dispatch((0,_features_main_store_bookingProfileSlice__WEBPACK_IMPORTED_MODULE_12__/* .setBookingProfile */ .uf)({
                            data: bookingProfile
                        }));
                        dispatch((0,_features_main_store_creatorProfileSlice__WEBPACK_IMPORTED_MODULE_11__/* .setCreatorProfile */ .I4)({
                            data: creatorProfile
                        }));
                        _ctx.next = 24;
                        return (0,_features_mini_store_share_api__WEBPACK_IMPORTED_MODULE_9__/* .fetchAllowStore */ .yK)(response._id);
                    case 24:
                        allowStore = _ctx.sent;
                        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(allowStore)) {
                            window["AllowStore"] = allowStore;
                        }
                        _ctx.next = 31;
                        break;
                    case 28:
                        _ctx.prev = 28;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,_features_share_helper_system__WEBPACK_IMPORTED_MODULE_13__/* .logError */ .H)(_ctx.t0, "Locale - fetchAccount");
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    28
                ]
            ]);
        }));
        return function fetchAccount() {
            return _ref.apply(this, arguments);
        };
    }();
    var getLocale = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (kol) {
                            _ctx.next = 3;
                            break;
                        }
                        fetchAccount().then();
                        return _ctx.abrupt("return");
                    case 3:
                        if (kol.locale) {
                            _app_i18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"].changeLanguage */ .Z.changeLanguage(kol.locale).then();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getLocale() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getLocale().then();
    }, [
        kol
    ]);
    if (!kol) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: " "
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};


/***/ })

}]);